import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectMoneyScale = createSelector(
  [selectConfigurationState],
  ({ moneyScale }) => moneyScale
)
